import React, { useState,useEffect } from 'react';
import Papa from 'papaparse';
import api from '../../../../services/api.js';
import DataMatrixBarcode from './components/DataMatrixBarcode.js';
import styles from './UploadAndSearchMarks.module.css';
import DeleteMarksModal from './components/DeleteMarksModal.js';

// Словарь для сопоставления GTIN с названием воды


// Функция форматирования даты из YYYY-MM-DD в дд/мм/гг
const formatDate = (dateString) => {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year.slice(2)}`;
};

const ITEMS_PER_PAGE = 28; // число марок на одной странице

const UploadAndSearchMarks = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  // Получаем сегодняшнюю дату в формате YYYY-MM-DD
  const today = new Date().toISOString().split('T')[0]; 
  const [uploadDate, setUploadDate] = useState(''); // Дата для маркировки при загрузке
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [marks, setMarks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedMark, setSelectedMark] = useState(null); // для модального окна
  const [deleteDate, setDeleteDate]         = useState('');
  const [deleteFilename, setDeleteFilename] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productMap, setProductMap] = useState({});
    useEffect(() => {
      api.get('/catalog-product/products').then(list => {
        const map = {};
        list.forEach(p => {
          if (p.gtin) map[p.gtin] = p.name;
        });
        setProductMap(map);
      });
    }, []);

  // Обработчик выбора CSV файла
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Загрузка CSV файла с марками
const handleUpload = async () => {
  if (!file) {
    setMessage('Пожалуйста, выберите CSV файл.');
    return;
  }
  if (!uploadDate) {
    setMessage('Пожалуйста, выберите дату маркировки.');
    return;
  }
  setUploading(true);
  setMessage('');

  try {
    // 1) Читаем файл полностью как текст
    const text = await file.text();
    // 2) Разбиваем по переводам строки (учитывая Windows и Unix)
    const lines = text.split(/\r?\n/).filter(line => line.trim());
    const marksToUpload = [];
    let fileGtin = null;

    // 3) Проходим по всем строкам
    lines.forEach((raw, i) => {
      const code = raw.trim();
      if (!code) return;
      if (i === 0 && code.length >= 16) {
        fileGtin = code.slice(2, 16);
      }
      marksToUpload.push({
        mark_date: uploadDate,
        mark_code: code,
        serial_number: i + 1,
        gtin: fileGtin,
        filename: file.name,
      });
    });

    // 4) Отправляем на сервер
    const res = await api.post('/marks/upload', marksToUpload);
    // если хотите показать число вставленных:
    const inserted = Array.isArray(res.inserted) ? res.inserted.length : marksToUpload.length;
    setMessage(`Загружено ${inserted} марок`);
  } catch (err) {
    console.error('Ошибка загрузки марки:', err);
    const errMsg = err.response?.data?.error || err.message || 'Неизвестная ошибка';
    setMessage(`Ошибка загрузки: ${errMsg}`);
  } finally {
    setUploading(false);
  }
};



  // Поиск марок по диапазону дат
  const handleSearch = async () => {
    if (!startDate || !endDate) {
      setMessage('Пожалуйста, введите начальную и конечную даты.');
      return;
    }
    setMessage('');
    try {
      const marksArray = await api.get(`/marks/search?startDate=${startDate}&endDate=${endDate}`);
      // сортируем по полю serial_number по возрастанию
      marksArray.sort((a, b) => a.serial_number - b.serial_number);
      setMarks(marksArray);
      setCurrentPage(1);
    } catch (error) {
      console.error('Ошибка поиска марок:', error);
      setMessage(`Ошибка поиска: ${error.message}`);
    }
  };

// Внутри UploadAndSearchMarks.jsx, перед return(...)
const handleDelete = async ({ date, filename }) => {
  // Для удобства выведем входные параметры
  console.log('🔴 handleDelete:', { date, filename });

  try {
    let url = '/marks/by-date-and-filename';
    let params = { date, filename };

    if (date && !filename) {
      url = '/marks/by-date';
      params = { date };
    } else if (filename && !date) {
      url = '/marks/by-filename';
      params = { filename };
    }

    // Выполняем DELETE-запрос
    const response = await api.delete(url, { params });
    console.log('🔴 delete response:', response);

    // Извлекаем сообщение об успехе или ошибке
    const msg = response.data?.message || response.data?.error || 'OK';
    setMessage(msg);

    // Закрываем модалку
    setShowDeleteModal(false);

    // По желанию: обновляем результаты текущего поиска
    if (startDate && endDate) {
      handleSearch();
    }
  } catch (err) {
    console.error('🔴 Ошибка в handleDelete:', err);
    const errMsg =
      err.response?.data?.error ||
      err.response?.data?.message ||
      err.message;
    setMessage(`Ошибка удаления: ${errMsg}`);
  }
};


  // Пагинация: вычисляем число страниц и отбираем марки для текущей страницы
  const totalPages = Math.ceil(marks.length / ITEMS_PER_PAGE);
  const currentMarks = marks.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  // Обработчик клика по марке – открытие модального окна с полной информацией о марке
  const openModal = async (markId) => {
    try {
      const markDetails = await api.get(`/marks/${markId}`);
      setSelectedMark(markDetails);
    } catch (error) {
      console.error('Ошибка получения деталей марки:', error);
      setMessage(`Ошибка получения деталей марки: ${error.message}`);
    }
  };

  // Закрытие модального окна
  const closeModal = () => {
    setSelectedMark(null);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Загрузка и поиск марок</h2>

      <section className={styles.section}>
        <h3 className={styles.subtitle}>Загрузка CSV</h3>
        <input className={styles.fileInput} type="file" accept=".csv" onChange={handleFileChange} />
        <input className={styles.dateInput} type="date" value={uploadDate} onChange={e => setUploadDate(e.target.value)} />
        <button className={styles.button} onClick={handleUpload} disabled={uploading}>
          {uploading ? 'Загрузка...' : 'Загрузить'}
        </button>
        <button
  className={styles.buttonDanger}
  onClick={() => setShowDeleteModal(true)}
>
  Удалить марки
</button>

      </section>


      <section className={styles.section}>
        <h3 className={styles.subtitle}>Поиск по датам</h3>
        <input className={styles.dateInput} type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
        <input className={styles.dateInput} type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
        <button className={styles.button} onClick={handleSearch}>Поиск</button>
      </section>

      {message && <p className={styles.message}>{message}</p>}

      <section className={styles.resultsSection}>
        <h3 className={styles.subtitle}>Результаты</h3>
        {marks.length === 0 ? (
          <p className={styles.noResults}>Ничего не найдено.</p>
        ) : (
          <div className={styles.grid}>
{currentMarks.map(mark => {
  const name = productMap[mark.gtin] || 'Неизвестно';
  return (
    <div
      key={mark.id}
      className={styles.card}
      onClick={() => openModal(mark.id)}
    >
      {/* Номер маршрута справа сверху */}
      {mark.routeListId != null && (
        <div className={styles.routeListBadge}>
          №{mark.routeListId}
        </div>
      )}

      <div className={styles.serial}>{mark.serial_number}</div>
      <DataMatrixBarcode value={mark.mark_code} className={styles.barcode} />
      <p className={styles.info}>
        {`${name} ${formatDate(mark.mark_date)}`}
      </p>
    </div>
  );
})}

          </div>
        )}
      </section>

      <div className={styles.pagination}>
        <button className={styles.pageButton} onClick={handlePrev} disabled={currentPage === 1}>←</button>
        <span className={styles.pageInfo}>{currentPage} / {totalPages}</span>
        <button className={styles.pageButton} onClick={handleNext} disabled={currentPage === totalPages}>→</button>
      </div>

      {selectedMark && (
        <div className={styles.backdrop} onClick={closeModal}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <h3 className={styles.subtitle}>Детали марки</h3>
            <pre className={styles.pre}>{JSON.stringify(selectedMark, null, 2)}</pre>
            <button className={styles.button} onClick={closeModal}>Закрыть</button>
          </div>
        </div>
      )}
      {showDeleteModal && (
  <DeleteMarksModal
    onClose={() => setShowDeleteModal(false)}
    onDelete={({ date, filename }) => {
      // здесь вызываем ваш общий handler удаления,
      // который сам разберёт, что именно удалять
      handleDelete({ date, filename });
    }}
  />
)}
    </div>
  );
};

export default UploadAndSearchMarks;
